import { render, staticRenderFns } from "./PurchasesProfile.vue?vue&type=template&id=e03976bc"
import script from "./PurchasesProfile.vue?vue&type=script&lang=js"
export * from "./PurchasesProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports